/* eslint-disable no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { _delete, _get, _patch, _post, _put } from "../../Services/baseApi";
import { errorHandler, successToast } from "../../Utils/toast";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  WARD_EXPORT_URL,
  WARD_IMPORT_URL,
  WARD_SAMPLE_URL,
  WARDS_ADD_URL,
  WARDS_LIST_URL,
  WARDS_DETAILS_URL,
  WARDS_DELETE_URL,
  WARDS_UPDATE_URL,
} from "../../Services/endpoints";
import { createMasterImportThunks } from "../../Utils/createMasterImportThunks";

const initialState = {
  isLoading: false,
  wardsList: {
    findWards: [],
    limit: 0,
    page: 0,
    totalCount: 0,
  },
};

const wardsSlice = createSlice({
  name: "wards",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // GET WARDS
    builder
      .addCase(getWardsThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getWardsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.wardsList = action.payload;
      })
      .addCase(getWardsThunk.rejected, (state) => {
        state.isLoading = false;
      });

    // ADD WARDS
    builder
      .addCase(addWardsThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addWardsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.wardsList = action.payload;
      })
      .addCase(addWardsThunk.rejected, (state) => {
        state.isLoading = false;
      });

    // UPDATE WARDS
    builder
      .addCase(updateWardsThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateWardsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.wardsList = action.payload;
      })
      .addCase(updateWardsThunk.rejected, (state) => {
        state.isLoading = false;
      });

    // DELETE WARDS
    builder
      .addCase(deleteWardsThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteWardsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.wardsList = action.payload;
      })
      .addCase(deleteWardsThunk.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

// export const {} = wardsSlice.actions;
// export default wardsSlice.reducer;

// Define the reducer export with persist data
export default persistReducer(
  {
    key: "wards/persist",
    storage,
    whitelist: [],
  },
  wardsSlice.reducer
);

export const getWardsThunk = createAsyncThunk(
  "wardsSlice/getWardsThunk",
  async (payload) => {
    try {
      const response = await _get(WARDS_LIST_URL, {
        page: payload?.page || undefined,
        limit: payload?.limit || undefined,
        name: payload?.name || undefined,
        key: payload?.key ? payload?.key : undefined,
        keyOrder:
          payload?.key && payload?.keyOrder ? payload?.keyOrder : undefined,
        cityId: payload?.cityId || undefined,
        zoneId: payload?.zoneId || undefined,
        stateId: payload?.stateId || undefined,
      });

      return response?.data?.result;
    } catch (error) {
      errorHandler(error);
    }
  }
);

export const addWardsThunk = createAsyncThunk(
  "wardsSlice/addWardsThunk",
  async (payload) => {
    try {
      const parsedNumber =
        payload.number === "" || payload.number == null
          ? undefined
          : Number(payload.number);
      const response = await _post(WARDS_ADD_URL, {
        name: payload.name,
        number:
          parsedNumber == null || Number.isNaN(parsedNumber)
            ? undefined
            : parsedNumber,
        zoneId: payload.zoneId,
      });
      payload.handleFun();
      successToast(response?.data?.message || "Ward Created Successfully");
      return response?.data?.result;
    } catch (error) {
      errorHandler(error);
    }
  }
);

export const updateWardsThunk = createAsyncThunk(
  "wardsSlice/updateWardsThunk",
  async (payload) => {
    try {
      const parsedNumber =
        payload.number === "" || payload.number == null
          ? undefined
          : Number(payload.number);
      const response = await _patch(WARDS_UPDATE_URL + `/${payload?.id}`, {
        id: payload.id,
        name: payload.name,
        number:
          parsedNumber == null || Number.isNaN(parsedNumber)
            ? undefined
            : parsedNumber,
        zoneId: payload.zoneId,
      });
      payload.handleFun();
      successToast(response?.data?.message || "Ward Updated Successfully");
      return response?.data?.data;
    } catch (error) {
      errorHandler(error);
    }
  }
);

const wardImportThunks = createMasterImportThunks({
  exportType: "wardsSlice",
  exportUrl: WARD_EXPORT_URL,
  importUrl: WARD_IMPORT_URL,
  sampleUrl: WARD_SAMPLE_URL,
  defaultExportFilename: "wards-export.xlsx",
  defaultSampleFilename: "wards-sample.xlsx",
  exportSuccessMessage: "Wards exported successfully",
});

export const exportWardsThunk = wardImportThunks.exportThunk;
export const downloadWardSampleThunk = wardImportThunks.downloadSampleThunk;
export const importWardsThunk = wardImportThunks.importThunk;

export const deleteWardsThunk = createAsyncThunk(
  "wardsSlice/deleteWardsThunk",
  async (payload) => {
    try {
      const response = await _delete(WARDS_DELETE_URL + `/${payload?.id}`);
      payload.handleFun();
      successToast(response?.data?.message || "Ward Deleted Successfully");

      return response?.data?.result;
    } catch (error) {
      errorHandler(error);
    }
  }
);
